<template>
  <div class="full-login font-poppins">
    <div class="w-full full">
      <Navbar />
      <div class="m-auto w-full">
        <div class="block sm:flex justify-center align-items-center w-full">
          <div class="h-screen xl:h-auto flex w-full" style="max-height: 600px">
            <div class="flex w-full">
              <div class="w-full min-w-1/2 flex-grow flex-shrink">
                <div class="my-4 mx-4 px-4 py-8">
                  <div class="intro-x mt-8 px-8">
                    <h1
                      class="font-crimson_pro text-theme-9 text-3xl font-semibold"
                    >
                      Mi perfil
                    </h1>
                  </div>
                  <div class="my-4 mx-4 px-4 rounded-md sm:w-11/12 w-full">
                    <div class="p-4 bg-theme-11 rounded-lg sm:p-8 shadow-md">
                      <div
                        class="flex flex-col md:flex-row md:justify-between items-center mb-4"
                      >
                        <img
                          class="w-8 h-8 rounded-full"
                          :src="getImageProfile()"
                          alt="user"
                          crossorigin="anonymous"
                        />
                        <h5
                          class="text-xl text-center font-bold leading-none text-gray-900"
                        >
                          {{ this.$store.state.auth.user?.name }}
                          {{ this.$store.state.auth.user?.last_name }}
                        </h5>
                        <a
                          href="javascript:;"
                          class="text-sm text-right md:text-right font-medium text-theme-9"
                          @click="showModalEditUserData"
                        >
                          Editar
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="my-4 mx-4 px-4 rounded-md sm:w-11/12 w-full">
                    <div
                      class="flex flex-col md:flex-row md:justify-between p-4 bg-theme-11 rounded-lg sm:p-8 shadow-md"
                    >
                      <div class="flex flex-col">
                        <p class="text-sm text-gray-500">Correo</p>
                        <p class="max-w-[150px] md:max-w-full">
                          {{ this.$store.state.auth.user?.email }}
                        </p>
                      </div>
                      <a
                        href="javascript:;"
                        class="text-sm text-right md:text-right font-medium text-theme-9"
                        @click="showModalEditUserEmail"
                      >
                        Cambiar
                      </a>
                    </div>
                  </div>
                  <div class="mb-4 mx-4 px-4 rounded-md sm:w-11/12 w-full">
                    <div
                      href="javascript:;"
                      class="block p-6 bg-theme-11 rounded-lg border border-gray-200 shadow-md"
                    >
                      <div
                        href="javascript:;"
                        @click="showModalEditPassword"
                        class="text-sm font-medium text-theme-9 text-right mb-2 cursor-pointer"
                      >
                        Cambiar
                      </div>
                      <p class="text-sm text-gray-500 truncate">Contraseña</p>
                      <div class="relative z-0">
                        <input
                          type="text"
                          id="disabled_standard"
                          class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                          placeholder=" "
                          disabled
                        />
                        <label
                          for="disabled_standard"
                          class="absolute text-sm text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                          >*****</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex min-w-1/3 lg:min-w-1/2 flex-grow hidden sm:flex">
                <img
                  alt="key"
                  class="m-auto"
                  :src="require(`@/assets/images/COT-img/Perfil.png`)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <Footer />
  </div>
  <!-- BEGIN: MODALS -->
  <edit-password-modal
    ref="editPassword"
    @edit-password-action="editPasswordAction"
  />
  <edit-user-data-modal
    ref="editUserData"
    @edit-user-data-action="editUserDataAction"
    :image-profile="getImageProfile()"
    @show-modal-set-avatar="showModalSetAvatar"
  />
  <edit-user-email-modal ref="editUserEmail" />

  <set-avatar-modal
    ref="setAvatar"
    @set-avatar-action="setAvatarAction"
    :image-profile="getImageProfile()"
  />

  <!-- END: MODALS -->
</template>

<style scoped>
.full {
  background-image: url('@/assets/images/COT-bg/Colorcitos.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.full-login {
  display: flex;
  min-height: 75vh;
  justify-content: center;
  background: #f0ecec;
}

.min-w-1\/3 {
  min-width: 33.333333%;
}

@media (width >= 64rem) {
  .lg\:min-w-1\/2 {
    min-width: 50%;
  }
}
</style>

<script>
import Navbar from '@/components/navbar/Main.vue'
import Footer from '@/components/footer/Main.vue'
import EditPasswordModal from './edit-password-modal.vue'
import EditUserDataModal from './edit-user-data-modal.vue'
import EditUserEmailModal from './edit-user-email-modal.vue'
import SetAvatarModal from './set-avatar-modal.vue'
import { getFirstErrorMessage, cleanSession } from '@/utils/tools'

export default {
  components: {
    Navbar,
    Footer,
    EditPasswordModal,
    EditUserDataModal,
    SetAvatarModal,
    EditUserEmailModal
  },
  data() {
    return {}
  },
  methods: {
    getImageProfile() {
      const avatarArray = this.$store.state?.auth?.user?.avatar
      return Array.isArray(avatarArray) && avatarArray.length
        ? avatarArray[0]
        : require('@/assets/images/user.svg')
    },
    showModalEditPassword() {
      return this.$refs.editPassword.viewModal('show')
    },
    async editPasswordAction({ oldPassword, password }) {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.post('/auth/sign-in-sales-operator', {
          email: this.$store.state?.auth?.user?.email,
          password: oldPassword
        })
        const token = response.data?.authorization?.access_token
        await this.axios.post(
          '/auth/modify-password',
          {
            new_password: password
          },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
        this.$toast.success('La contraseña ha sido cambiada correctamente', {
          position: 'top'
        })
        cleanSession(this.$store, this.$router)
      } catch (error) {
        console.log(error)
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$refs.editPassword.viewModal('hide')
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    showModalEditUserData() {
      return this.$refs.editUserData.viewModal('show')
    },
    async editUserDataAction({ name, lastName }) {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.post(
          '/auth/modify-user-data',
          {
            name: name,
            last_name: lastName
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.$store.commit('auth/setUserData', {
          user: response.data.user
        })
        this.$toast.success('La información ha sido cambiada correctamente', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$refs.editUserData.viewModal('hide')
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    showModalSetAvatar() {
      this.$refs.editUserData.viewModal('hide')
      setTimeout(() => {
        this.$refs.setAvatar.viewModal('show')
      }, 500)
    },
    async setAvatarAction({ avatarSelected }) {
      const imageName = `user${avatarSelected}.png`
      const imageString = require(`@/assets/images/COT-img/avatares/${imageName}`)
      const res = await fetch(imageString)
      const blob = await res.blob()
      const file = new File([blob], imageName, { type: 'image/png' })
      this.$store.commit('main/setShowSpinner', true)
      const modal = this.$refs.changeAvatarModal
      cash(modal).modal('hide')
      try {
        const formData = new FormData()
        formData.append('image', file)
        const response = await this.axios.post(
          '/auth/modify-image-profile',
          formData,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`,
              'Content-Type': 'multipart/form-data',
              Accept: 'application/json'
            }
          }
        )
        this.$store.commit(
          'auth/setUserImageProfile',
          response.data.user?.avatar
        )
        this.image = this.getImageProfile()
        this.$toast.success('La imagen ha sido cambiada correctamente', {
          position: 'top'
        })
      } catch (error) {
        console.log(error)
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$refs.setAvatar.viewModal('hide')
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    showModalEditUserEmail() {
      return this.$refs.editUserEmail.viewModal('show')
    }
  }
}
</script>
